import { css } from 'styled-components';

type TypographyKey = keyof typeof typographyObj;
type FontWeight =
  | 'normal'
  | 'bold'
  | 'lighter'
  | 'bolder'
  | 100
  | 200
  | 300
  | 400
  | 500
  | 600
  | 700
  | 800
  | 900
  | 'inherit'
  | 'initial'
  | 'unset';

const typographyObj = {
  $largetitle_01: css`
    font-size: 34px;
    font-style: normal;
    line-height: 41px; /* 120.588% */
    letter-spacing: 0.374px;
  `,
  $title_01: css`
    font-size: 28px;
    font-style: normal;
    line-height: 34px; /* 121.429% */
    letter-spacing: 0.36px;
  `,
  $title_02: css`
    font-size: 22px;
    font-style: normal;
    line-height: 28px; /* 127.273% */
    letter-spacing: 0.35px;
  `,
  $title_03: css`
    font-size: 20px;
    font-style: normal;
    line-height: 24px; /* 120% */
    letter-spacing: 0.38px;
  `,
  $headline_01: css`
    font-size: 18px;
    font-style: normal;
    line-height: 22px; /* 122.222% */
    letter-spacing: -0.408px;
  `,
  $body_01: css`
    font-size: 17px;
    font-style: normal;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.41px;
  `,
  $body_02: css`
    font-size: 16px;
    font-style: normal;
    line-height: 21px; /* 131.25% */
    letter-spacing: -0.32px;
  `,
  $body_03: css`
    font-size: 14px;
    font-style: normal;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.5px;
  `,
  $caption_01: css`
    font-size: 13px;
    font-style: normal;
    line-height: 18px; /* 138.462% */
    letter-spacing: -0.078px;
  `,
  $caption_02: css`
    font-size: 12px;
    font-style: normal;
    line-height: 16px; /* 133.333% */
  `,
  $caption_03: css`
    font-size: 10px;
    font-style: normal;
    line-height: 13px; /* 130% */
    letter-spacing: 0.066px;
  `
} as const;

export function typography(key: TypographyKey, weight?: FontWeight) {
  return css`
    font-family: 'Pretendard Variable';
    font-weight: ${weight ?? 400};
    ${typographyObj[key]}
  `;
}
